var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#7D92A9","d":"M20 5.396A5.39 5.39 0 0014.615 0 5.379 5.379 0 0010 2.616a5.381 5.381 0 00-10 2.78A5.39 5.39 0 001.7 9.33h-.002l7.709 7.392a.766.766 0 001.15.036l7.746-7.428h-.002A5.393 5.393 0 0020 5.396"}));
}

Heart.defaultProps = {"width":"20","height":"17","viewBox":"0 0 20 17"};

module.exports = Heart;

Heart.default = Heart;
